import React from 'react';
import DarkModeToggle from './DarkModeToggle';
import '../../styles/components/Header.css';

const Header = () => {
  return (
    <header>
      <div className="header-content">
        <div className="header-left">
          <h1>William Lazuardi</h1>
          <h4>Software Engineering Lead</h4>
        </div>
        <div className="header-right">
          <DarkModeToggle />
        </div>
      </div>
    </header>
  );
};

export default Header; 